import clsx from 'clsx';
import React from 'react';

const Badge = ({ children, className, appearance = 'info', ...props }) => (
  <div
    className={clsx(
      className,
      'inline-block first-letter:uppercase rounded text-xs font-semibold py-0.5 px-1',
      {
        'bg-green-300 text-white': appearance === 'success',
        'bg-orange-500 text-white': appearance === 'warning',
        'bg-red-500 text-white': appearance === 'error',
        'bg-gray-500 text-white': appearance === 'info',
        'bg-none text-gray-500': appearance === 'outline',
      },
    )}
    {...props}
  >
    {children}
  </div>
);

export default Badge;
